/**
 * 資格・免許区分のEnum（大区分）
 */
export const LicenseCategory = {
  SEAMANS_BOOK: "SEAMANS_BOOK", // 船員手帳
  HEALTH_CERTIFICATE: "HEALTH_CERTIFICATE", // 健康証明書
  COC: "COC", // 海技免状
  SMALL_BOAT_OPERATOR_LICENSE: "SMALL_BOAT_OPERATOR_LICENSE", // 小型船舶操縦免許
  RADIO_OPERATOR: "RADIO_OPERATOR", // 無線従事者
  DANGEROUS_GOODS_HANDLING_OFFICER: "DANGEROUS_GOODS_HANDLING_OFFICER", // 危険物取扱責任者
  DECK_WATCHKEEPER: "DECK_WATCHKEEPER", // 航海当直部員
  SANITATION_MANAGER: "SANITATION_MANAGER", // 衛生管理者
  LIFEBOATMAN: "LIFEBOATMAN", // 救命艇手
  STCW_TRAINING: "STCW_TRAINING", // STCW訓練
  ECDIS_TRAINING: "ECDIS_TRAINING", // ECDIS講習
  DESIGNATED_AREA_OPERATIONS_MANAGER: "DESIGNATED_AREA_OPERATIONS_MANAGER", // 特定海域運航責任者
  PASSPORT: "PASSPORT", // パスポート
  OTHERS: "OTHERS", // その他
};
export const LicenseCategoryLabels = {
  [LicenseCategory.SEAMANS_BOOK]: "船員手帳",
  [LicenseCategory.HEALTH_CERTIFICATE]: "健康証明書",
  [LicenseCategory.COC]: "海技免状",
  [LicenseCategory.SMALL_BOAT_OPERATOR_LICENSE]: "小型船舶操縦免許",
  [LicenseCategory.RADIO_OPERATOR]: "無線従事者",
  [LicenseCategory.DANGEROUS_GOODS_HANDLING_OFFICER]: "危険物取扱責任者",
  [LicenseCategory.DECK_WATCHKEEPER]: "航海当直部員",
  [LicenseCategory.SANITATION_MANAGER]: "衛生管理者",
  [LicenseCategory.LIFEBOATMAN]: "救命艇手",
  [LicenseCategory.STCW_TRAINING]: "STCW訓練",
  [LicenseCategory.ECDIS_TRAINING]: "ECDIS講習",
  [LicenseCategory.DESIGNATED_AREA_OPERATIONS_MANAGER]: "特定海域運航責任者",
  [LicenseCategory.PASSPORT]: "パスポート",
  [LicenseCategory.OTHERS]: "その他",
};

export const LicenseCategoryPriority = [
  LicenseCategory.SEAMANS_BOOK,
  LicenseCategory.HEALTH_CERTIFICATE,
  LicenseCategory.COC,
  LicenseCategory.SMALL_BOAT_OPERATOR_LICENSE,
  LicenseCategory.RADIO_OPERATOR,
  LicenseCategory.DANGEROUS_GOODS_HANDLING_OFFICER,
  LicenseCategory.DECK_WATCHKEEPER,
  LicenseCategory.SANITATION_MANAGER,
  LicenseCategory.LIFEBOATMAN,
  LicenseCategory.STCW_TRAINING,
  LicenseCategory.ECDIS_TRAINING,
  LicenseCategory.DESIGNATED_AREA_OPERATIONS_MANAGER,
  LicenseCategory.PASSPORT,
  LicenseCategory.OTHERS,
].reduce((acc, category, index) => {
  acc[category] = index;
  return acc;
}, {});

/**
 * 船員手帳の小区分
 */
export const SeamansBookSubCategory = {
  1: "SEAMANS_BOOK",
};
export const SeamansBookSubCategoryLabels = {
  [SeamansBookSubCategory[1]]: "船員手帳",
};

/**
 * 健康証明書の小区分
 */
export const HealthCertificateSubCategory = {
  1: "HEALTH_CERTIFICATE",
};
export const HealthCertificateSubCategoryLabels = {
  [HealthCertificateSubCategory[1]]: "健康証明書",
};

/**
 * 海技免状の小区分
 */
export const COCSubCategory = {
  1: "NAVIGATION", // 航海
  2: "ENGINE", // 機関
  3: "COMMUNICATION", // 通信
  4: "ELECTRONIC_COMMUNICATION", // 電子通信
};
export const COCSubCategoryLabels = {
  [COCSubCategory[1]]: "航海",
  [COCSubCategory[2]]: "機関",
  [COCSubCategory[3]]: "通信",
  [COCSubCategory[4]]: "電子通信",
};

/**
 * 小型船舶操縦免許の小区分
 */
export const SmallVesselSubCategory = {
  1: "STANDARD", // 普通
  2: "SPECIFIC", // 特定
};
export const SmallVesselSubCategoryLabels = {
  [SmallVesselSubCategory[1]]: "普通",
  [SmallVesselSubCategory[2]]: "特定",
};

/**
 * 無線従事者の小区分
 */
export const RadioOperatorSubCategory = {
  1: "GENERAL", // 総合無線従事者
  2: "MARITIME", // 海上無線従事者
  3: "MARITIME_SPECIAL", // 海上特殊無線技士
  4: "RADAR_MARITIME_SPECIAL", // レーダー級海上特殊無線技士
};
export const RadioOperatorSubCategoryLabels = {
  [RadioOperatorSubCategory[1]]: "総合無線従事者",
  [RadioOperatorSubCategory[2]]: "海上無線従事者",
  [RadioOperatorSubCategory[3]]: "海上特殊無線技士",
  [RadioOperatorSubCategory[4]]: "レーダー級海上特殊無線技士",
};

/**
 * 危険物取扱責任者の小区分
 */
export const DangerousGoodsHandlingOfficerSubCategory = {
  1: "PETROLEUM_LIQUID_CHEMICAL", // 石油・液体化学薬品
  2: "LIQUEFIED_GAS", // 液化ガス
  3: "LOW_FLASH_POINT_FUEL", // 低引火点燃料
};
export const DangerousGoodsHandlingOfficerSubCategoryLabels = {
  [DangerousGoodsHandlingOfficerSubCategory[1]]: "石油・液体化学薬品",
  [DangerousGoodsHandlingOfficerSubCategory[2]]: "液化ガス",
  [DangerousGoodsHandlingOfficerSubCategory[3]]: "低引火点燃料",
};

/**
 * 航海当直部員の小区分
 */
export const DeckWatchkeeperSubCategory = {
  1: "DECK_WATCHKEEPER",
};
export const DeckWatchkeeperSubCategoryLabels = {
  [DeckWatchkeeperSubCategory[1]]: "航海当直部員",
};

/**
 * 衛生管理者の小区分
 */
export const SanitationManagerSubCategory = {
  1: "SANITATION_MANAGER",
};
export const SanitationManagerSubCategoryLabels = {
  [SanitationManagerSubCategory[1]]: "衛生管理者",
};

/**
 * 救命艇手の小区分
 */
export const LifeboatmanSubCategory = {
  1: "LIFEBOATMAN",
};
export const LifeboatmanSubCategoryLabels = {
  [LifeboatmanSubCategory[1]]: "救命艇手",
};

/**
 * STCW訓練の小区分
 */
export const StcwTrainingSubCategory = {
  1: "STCW_TRAINING",
};
export const StcwTrainingSubCategoryLabels = {
  [StcwTrainingSubCategory[1]]: "STCW訓練",
};

/**
 * ECDIS講習の小区分
 */
export const EcdisTrainingSubCategory = {
  1: "ECDIS_TRAINING",
};
export const EcdisTrainingSubCategoryLabels = {
  [EcdisTrainingSubCategory[1]]: "ECDIS講習",
};

/**
 * 特定海域運航責任者の小区分
 */
export const DesignatedAreaOperationsManagerSubCategory = {
  1: "DESIGNATED_AREA_OPERATIONS_MANAGER",
};
export const DesignatedAreaOperationsManagerSubCategoryLabels = {
  [DesignatedAreaOperationsManagerSubCategory[1]]: "特定海域運航責任者",
};

/**
 * パスポートの小区分
 */
export const PassportSubCategory = {
  1: "PASSPORT",
};
export const PassportSubCategoryLabels = {
  [PassportSubCategory[1]]: "パスポート",
};

/**
 * その他の小区分
 */
export const OthersSubCategory = {
  1: "OTHERS",
};
export const OthersSubCategoryLabels = {
  [OthersSubCategory[1]]: "その他",
};

/**
 * 小区分の大区分マッピング
 */
export const LicenseSubCategoryMapping = {
  // 船員手帳
  [SeamansBookSubCategory[1]]: LicenseCategory.SEAMANS_BOOK,
  // 健康証明書
  [HealthCertificateSubCategory[1]]: LicenseCategory.HEALTH_CERTIFICATE,
  // 海技免状
  [COCSubCategory[1]]: LicenseCategory.COC,
  [COCSubCategory[2]]: LicenseCategory.COC,
  [COCSubCategory[3]]: LicenseCategory.COC,
  [COCSubCategory[4]]: LicenseCategory.COC,
  // 小型船舶操縦免許
  [SmallVesselSubCategory[1]]: LicenseCategory.SMALL_BOAT_OPERATOR_LICENSE,
  [SmallVesselSubCategory[2]]: LicenseCategory.SMALL_BOAT_OPERATOR_LICENSE,
  // 無線従事者
  [RadioOperatorSubCategory[1]]: LicenseCategory.RADIO_OPERATOR,
  [RadioOperatorSubCategory[2]]: LicenseCategory.RADIO_OPERATOR,
  [RadioOperatorSubCategory[3]]: LicenseCategory.RADIO_OPERATOR,
  [RadioOperatorSubCategory[4]]: LicenseCategory.RADIO_OPERATOR,
  // 危険物取扱責任者
  [DangerousGoodsHandlingOfficerSubCategory[1]]:
    LicenseCategory.DANGEROUS_GOODS_HANDLING_OFFICER,
  [DangerousGoodsHandlingOfficerSubCategory[2]]:
    LicenseCategory.DANGEROUS_GOODS_HANDLING_OFFICER,
  [DangerousGoodsHandlingOfficerSubCategory[3]]:
    LicenseCategory.DANGEROUS_GOODS_HANDLING_OFFICER,
  // 航海当直部員
  [DeckWatchkeeperSubCategory[1]]: LicenseCategory.DECK_WATCHKEEPER,
  // 衛生管理者
  [SanitationManagerSubCategory[1]]: LicenseCategory.SANITATION_MANAGER,
  // 救命艇手
  [LifeboatmanSubCategory[1]]: LicenseCategory.LIFEBOATMAN,
  // STCW訓練
  [StcwTrainingSubCategory[1]]: LicenseCategory.STCW_TRAINING,
  // ECDIS講習
  [EcdisTrainingSubCategory[1]]: LicenseCategory.ECDIS_TRAINING,
  // 特定海域運航責任者
  [DesignatedAreaOperationsManagerSubCategory[1]]:
    LicenseCategory.DESIGNATED_AREA_OPERATIONS_MANAGER,
  // パスポート
  [PassportSubCategory[1]]: LicenseCategory.PASSPORT,
  // その他
  [OthersSubCategory[1]]: LicenseCategory.OTHERS,
};

/**
 * カテゴリが「船員手帳」かどうかを判定
 * @param {string} category - 大区分
 * @returns {boolean}
 */
export const isSeamansBookCategory = category => {
  return category === LicenseCategory.SEAMANS_BOOK;
};

/**
 * カテゴリが「海技免状」かどうかを判定
 * @param {string} category - 大区分
 * @returns {boolean}
 */
export const isCOCCategory = category => {
  return category === LicenseCategory.COC;
};

/**
 * 大区分と小区分をもとに、小区分の内部定数を返す
 * @param {string} category - 大区分 (LicenseCategory の値)
 * @param {number} subCategoryKey - 小区分の数字キー
 * @returns {string|null} - 小区分のラベル、存在しない場合はnull
 */
export const getSubCategory = (category, subCategoryKey) => {
  /**
   * 大区分ごとの小区分マッピング
   */
  const subCategoryMap = {
    [LicenseCategory.SEAMANS_BOOK]: SeamansBookSubCategory,
    [LicenseCategory.HEALTH_CERTIFICATE]: HealthCertificateSubCategory,
    [LicenseCategory.COC]: COCSubCategory,
    [LicenseCategory.SMALL_BOAT_OPERATOR_LICENSE]: SmallVesselSubCategory,
    [LicenseCategory.RADIO_OPERATOR]: RadioOperatorSubCategory,
    [LicenseCategory.DANGEROUS_GOODS_HANDLING_OFFICER]: DangerousGoodsHandlingOfficerSubCategory,
    [LicenseCategory.DECK_WATCHKEEPER]: DeckWatchkeeperSubCategory,
    [LicenseCategory.SANITATION_MANAGER]: SanitationManagerSubCategory,
    [LicenseCategory.LIFEBOATMAN]: LifeboatmanSubCategory,
    [LicenseCategory.STCW_TRAINING]: StcwTrainingSubCategory,
    [LicenseCategory.ECDIS_TRAINING]: EcdisTrainingSubCategory,
    [LicenseCategory.DESIGNATED_AREA_OPERATIONS_MANAGER]: DesignatedAreaOperationsManagerSubCategory,
    [LicenseCategory.PASSPORT]: PassportSubCategory,
    [LicenseCategory.OTHERS]: OthersSubCategory,
  };

  const subCategoryByCategory = subCategoryMap[category];
  if (!subCategoryByCategory) {
    return null;
  }

  return subCategoryByCategory[subCategoryKey];
};

export default {
  LicenseCategory,
  LicenseCategoryLabels,
  LicenseCategoryPriority,
  SeamansBookSubCategory,
  SeamansBookSubCategoryLabels,
  HealthCertificateSubCategory,
  HealthCertificateSubCategoryLabels,
  COCSubCategory,
  COCSubCategoryLabels,
  SmallVesselSubCategory,
  SmallVesselSubCategoryLabels,
  RadioOperatorSubCategory,
  RadioOperatorSubCategoryLabels,
  DangerousGoodsHandlingOfficerSubCategory,
  DangerousGoodsHandlingOfficerSubCategoryLabels,
  DeckWatchkeeperSubCategory,
  DeckWatchkeeperSubCategoryLabels,
  SanitationManagerSubCategory,
  SanitationManagerSubCategoryLabels,
  LifeboatmanSubCategory,
  LifeboatmanSubCategoryLabels,
  StcwTrainingSubCategory,
  StcwTrainingSubCategoryLabels,
  EcdisTrainingSubCategory,
  EcdisTrainingSubCategoryLabels,
  DesignatedAreaOperationsManagerSubCategory,
  DesignatedAreaOperationsManagerSubCategoryLabels,
  PassportSubCategory,
  PassportSubCategoryLabels,
  OthersSubCategory,
  OthersSubCategoryLabels,

  LicenseSubCategoryMapping,
  isSeamansBookCategory,
  isCOCCategory,
  getSubCategory,
};
